import store from "@/store";
import { Shift } from "@/api";

const shifts = () => {
  const stateShifts = store.getters["shift/shifts"];
  if (!stateShifts || !Array.isArray(stateShifts)) {
    return [
      {
        id: 0,
        name: "Day Shift",
      },
      {
        id: 1,
        name: "Evening Shift",
      },
      {
        id: 2,
        name: "Night Shift",
      },
      {
        id: 3,
        name: "PRN Day shift",
      },
      {
        id: 4,
        name: "PRN Evening shift",
      },
      {
        id: 5,
        name: "PRN Night shift",
      },
      {
        id: 6,
        name: "Part Time Day shift",
      },
      {
        id: 7,
        name: "Part Time Evening shift",
      },
      {
        id: 8,
        name: "Part Time Night shift",
      },
    ];
  }
  return stateShifts.map((shift: Shift) => ({
    id: shift.id,
    name: shift.shift,
  }));
};

export default shifts;
